export default "__VITE_ASSET__IqdUMOAI__"